import { useState, useEffect, useRef } from "react";
import Layout from "../../Layout";
import {
  requestAnuncios,
  requestFavoritos,
  requestRecientes,
} from "../../actions/dashboard";
import { useSelector, useDispatch } from "react-redux";
import { DivContainer, ItemSpan, SwiperContainer } from "./styled.components";
import { findInMenu } from "utils";

import { SwiperSlide } from "swiper/react";

import { Navigation, Autoplay, Pagination } from "swiper";
import { IconButton } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { modules } = useSelector((state: any) => state.user);
  const [anuncios, setAnuncios] = useState([]);
  const [menuLateral, setMenuLateral] = useState([
    { id: 1, text: "Favoritos", children: null },
    { id: 2, text: "Recientes", children: null },
  ]);

  const { primary, menuLateralTheme, colorBullet, dashboardTheme } =
    useSelector((state: any) => state.theme);


  const handleAnuncios = async () => {
    const anuncios = await requestAnuncios();
    let items: any = [];
    if (anuncios) {
      items = anuncios.map((anuncio: any) => {
        return {
          src: anuncio.signPath,
          altText: anuncio.codigoAnuncio,
          caption: anuncio.anuncio,
        };
      });
    }
    setAnuncios(items);
  };

  const handleMenuLateral = async () => {
    Promise.all([requestFavoritos(), requestRecientes()]).then(
      (response: any) => {
        let arrayResponse: any = [];
        if (response) {
          if (response[0]) {
            arrayResponse.push({
              id: 1,
              text: "Favoritos",
              children: response[0]
                .filter((item: any) => findInMenu(item, modules))
                .map((favorito: any) => {
                  return {
                    id: favorito.idVista,
                    text: favorito.vista,
                    module: favorito.url.toLowerCase().replace(/\s/g, ""),
                    reportPath: favorito.rutaReporte,
                  };
                }),
            });
          }
          if (response[1]) {
            arrayResponse.push({
              id: 2,
              text: "Recientes",
              children: response[1]
                .filter((item: any) => findInMenu(item, modules))
                .map((favorito: any) => {
                  return {
                    id: favorito.idVista,
                    text: favorito.vista,
                    module: favorito.url.toLowerCase().replace(/\s/g, ""),
                    reportPath: favorito.rutaReporte,
                  };
                }),
            });
          }
        }

        let existFav = arrayResponse.findIndex((item: any) => item.id === 1);
        if (existFav < 0) {
          arrayResponse = [
            { id: 1, text: "Favoritos", children: [] },
            ...arrayResponse,
          ];
        }

        let existR = arrayResponse.findIndex((item: any) => item.id === 2);
        if (existR < 0) {
          arrayResponse = [
            ...arrayResponse,
            { id: 2, text: "Recientes", children: [] },
          ];
        }

        dispatch({
          type: "SET_MENULATERAL",
          menu: arrayResponse,
        });
        setMenuLateral(arrayResponse);
      }
    );
  };

  useEffect(() => {
    handleAnuncios();
    handleMenuLateral();
  }, []);

  const handleLink = (item: any) => {
    let url =
      item.module === "powerbi" || item.module === "ssrs"
        ? `report/${item.id}/${item.module.toUpperCase()}`
        : item.module;

    const open = window.open(url, "_blank");
    if (open) {
      open.focus();
    }
  };

  const handleChildren = (item: any, index: number) => (
    <ItemSpan
      className={"children"}
      bg={menuLateralTheme?.itemColor}
      hover={menuLateralTheme?.hoverColor}
    >
      <span
        className={"children-items"}
        style={{ color: menuLateralTheme?.textColor }}
        onClick={() => handleLink(item)}
      >
        <div
          className={"circle"}
          style={{
            backgroundColor: colorBullet || menuLateralTheme?.textColor,
          }}
        />
        &nbsp;{item.text}
      </span>
    </ItemSpan>
  );

  const handleRender = (item: any, index: number) => {
    const { children } = item;
    return (
      <div
        className={"card-item"}
        style={{ backgroundColor: menuLateralTheme?.bgColor }}
      >
        <div
          className={"head"}
          style={{ backgroundColor: menuLateralTheme?.headBg }}
        >
          <span style={{ color: menuLateralTheme?.headTextColor }}>
            {item.text}
          </span>
        </div>
        <div
          className={"body"}
          style={{
            backgroundColor: menuLateralTheme?.bgColor,
            borderColor: menuLateralTheme?.bgColor,
          }}
        >
          {children && children.map(handleChildren)}
        </div>
      </div>
    );
  };

  return (
    <Layout
      hiddenBg={
        dashboardTheme && Object.keys(dashboardTheme).length > 0 ? true : false
      }
    >
      <div
        className={"dash-container"}
        style={
          dashboardTheme && Object.keys(dashboardTheme).length
            ? {
                backgroundImage: `url(${dashboardTheme.imagen})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "20% center",
              }
            : {}
        }
      >
        <div className={"dash-element-carouselslider"}>
          <DivContainer
            arrowColor={dashboardTheme?.arrowColor}
            bgContainerAnuncios={dashboardTheme?.bgAnuncios}
          >
            <IconButton className="swiper-button-prev">
              <ArrowBackIosNewIcon className="icons" />
            </IconButton>
            <SwiperContainer
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              centeredSlides={true}
              autoplay={{
                delay: 10000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              modules={[Autoplay, Pagination, Navigation]}
            >
              {anuncios.map((data: any, index: number) => (
                <SwiperSlide>
                  <img src={data.src} alt={data.alt} />{" "}
                </SwiperSlide>
              ))}
            </SwiperContainer>
            <IconButton className="swiper-button-next">
              <ArrowForwardIosIcon className="icons" />{" "}
            </IconButton>
          </DivContainer>
        </div>
        <div className={"card-container"}>{menuLateral.map(handleRender)}</div>
      </div>
    </Layout>
  );
};

export default Dashboard;
